// extracted by mini-css-extract-plugin
export default {"page":"WY-z","cartModal":"XY-z","checkout":"YY-z","placeholder":"ZY-z","account":"_Y-z"};